/**
 * Application version
 * Auto-generated from package.json during build
 * Do not edit manually - changes will be overwritten
 */
export const APP_VERSION = '1.0.15';
